/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { XeroIssueLogRestService } from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { XeroIssueLogModel } from './xero-issue-log.model';

@Injectable()
export class XeroIssueLogBusinessService implements InitViewService {
  constructor(
    private xeroIssueLogRestService: XeroIssueLogRestService,
    private gridLayoutService: GridLayoutService) {
  }

  initView(): any {
    return {
      gridLayout: this.gridLayoutService.get('xeroIssueLog'),
    };
  }

  findAllAsDataSource(filter: any): SlicedDataSource<XeroIssueLogModel> {
    return this.xeroIssueLogRestService.findAllAsDataSource(filter);
  }
}
